import React from 'react'
import { Link } from 'react-router-dom'
import { getDateTime, getMoment } from '../../../../utils/dateTime'
import { IconDelete, IconDuplicate } from '../../../../svg'
import IconDrawGirl from '../../../../svg/drawGirl.svg'
import Pagination from '../../../../components/Pagination'
import Actions from '../../../../components/Actions'

export const DraftsTab = ({
    projects,
    t,
    getTranslation,
    actionLoading,
    openModal,
    editClick,
    duplicateProject,
    isTrial,
    openTrialModal,
    paginationClick,
}) => {
    return (
        <div className={`tab-content${projects.published.isLoading ? ' dim' : ''}`}>
            {projects.drafts.content.length ? (
                <ul className={`project-list${projects.drafts.isLoading ? ' dim' : ''}`}>
                    {projects.drafts.content.map(item => {
                        return (
                            <li
                                className={`item${item.isRemoved ? ' is-removed' : ''}${
                                    item.projectBlockStatus === 'BLOCKED' ? ' is-blocked' : ''
                                }`}
                                key={item.id}
                                data-deleted-text="deleted"
                                data-blocked-text="blocked"
                            >
                                <div className="mobile-box">
                                    <div className="head">
                                        <div className="name">
                                            <h3>{item.name}</h3>
                                            <div
                                                style={{
                                                    color: item.projectType.color,
                                                    borderColor: item.projectType.color,
                                                }}
                                            >
                                                {/* START > Временно пока нет многоязычности в админке */}
                                                {getTranslation(item.projectType.customId, 'name')}
                                                {/* END */}
                                                {/*{item.projectType.name}*/}
                                            </div>
                                        </div>
                                        <div className="actions us-n">
                                            <div>
                                                <ul className="btn" onClick={openModal('mobile_actions', item)}>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    {item.previewUrl && item.mobilePreviewUrl ? (
                                        <div className="images">
                                            <div className="image-container image-container--desktop">
                                                <div className="layout">
                                                    <ul>
                                                        <li></li>
                                                        <li></li>
                                                        <li></li>
                                                    </ul>
                                                </div>
                                                <img src={item.previewUrl} alt="" />
                                            </div>
                                            <div className="image-container image-container--mobile">
                                                <div className="layout">
                                                    <span></span>
                                                </div>
                                                <img src={item.mobilePreviewUrl} alt="" />
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="buttons">
                                        <div></div>
                                        <div>
                                            <button
                                                className="button"
                                                data-size="md"
                                                data-variant="primary"
                                                onClick={editClick(item)}
                                            >
                                                {t('Edit')}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="box">
                                    <div className="block block--1 us-n">
                                        <div className="image-container image-container--desktop">
                                            <div className="layout">
                                                <ul>
                                                    <li></li>
                                                    <li></li>
                                                    <li></li>
                                                </ul>
                                            </div>
                                            {item.previewUrl ? (
                                                <img src={item.previewUrl} alt="" />
                                            ) : (
                                                <div className="no-image"></div>
                                            )}
                                        </div>
                                        <div className="image-container image-container--mobile">
                                            <div className="layout">
                                                <span></span>
                                            </div>
                                            {item.mobilePreviewUrl ? (
                                                <img src={item.mobilePreviewUrl} alt="" />
                                            ) : (
                                                <div className="no-image"></div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="block block--2">
                                        <div className="block block--1">
                                            <h3>{item.name}</h3>
                                            <div
                                                className="category us-n"
                                                style={{
                                                    color: item.projectType.color,
                                                    borderColor: item.projectType.color,
                                                }}
                                            >
                                                {/* START > Временно пока нет многоязычности в админке */}
                                                {getTranslation(item.projectType.customId, 'name')}
                                                {/* END */}
                                                {/*{item.projectType.name}*/}
                                            </div>
                                        </div>
                                        <div className="block block--2">
                                            {getMoment(item.updated).isValid() && (
                                                <div>
                                                    {t('_pages._my_projects.last_modified')}:{' '}
                                                    {getDateTime(item.updated)}
                                                </div>
                                            )}
                                            {getMoment(item.created).isValid() && (
                                                <div>
                                                    {t('_pages._my_projects.created')}: {getDateTime(item.created)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="box">
                                    <div className="block block--3 jc-fe">
                                        <Actions align="right">
                                            <div className="block block--1">
                                                <ul className="items-1">
                                                    <li
                                                        className={actionLoading.duplicateProject ? 'is-loading' : ''}
                                                        onClick={duplicateProject(item)}
                                                    >
                                                        <span className="icon" data-icon="duplicate">
                                                            <IconDuplicate />
                                                        </span>
                                                        {t('_pages._my_projects.duplicate_project')}
                                                    </li>
                                                    <li onClick={openModal('delete_project', item)}>
                                                        <span className="icon" data-icon="delete">
                                                            <IconDelete />
                                                        </span>
                                                        {t('_common.delete')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </Actions>
                                        <div className="block block--2">
                                            <div className="button-list">
                                                <button
                                                    className="button"
                                                    data-size="md"
                                                    data-variant="primary"
                                                    onClick={isTrial ? openTrialModal() : editClick(item)}
                                                    data-test="edit-project"
                                                >
                                                    {t('Edit')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            ) : projects.drafts.isLoading ? (
                t('_common.loading')
            ) : (
                <div className="empty">
                    <div className="image">
                        <img src={IconDrawGirl} alt="" />
                    </div>
                    <h3>{t('_pages._my_projects.text_1')}</h3>
                    <h4>{t('_pages._my_projects.text_2')}</h4>
                    <div className="buttons">
                        <Link to={`/template-gallery`} className="button-style" data-size="lg" data-variant="primary">
                            {t('_pages._my_projects.create_from_template')}
                        </Link>
                    </div>
                </div>
            )}
            <div className={`pagination-wrapper${projects.drafts.pagination.totalPages > 1 ? ' is-visible' : ''}`}>
                <Pagination
                    settings={{ disableInitCallback: true, marginPages: 2, pageRange: 3 }}
                    data={{
                        currentPage: projects.drafts.pagination.offsetPages,
                        totalPages: projects.drafts.pagination.totalPages,
                    }}
                    events={{ handleClick: paginationClick('drafts') }}
                />
            </div>
        </div>
    )
}
